<template>
  <t-form :requiredMark="option.attribute.required" :labelAlign="option.attribute.labelAlign" :style="setStyles">
      <t-form-item :label="option.attribute.label" class="my_date_picker" :style="setStyles">
        <div v-if="option.attribute.daterange">
            <t-date-range-picker v-model="checkedValDate" class="my_date_picker_item" :class="option.attribute.labelAlign" :placeholder="option.attribute.placeholder"  v-if="option.attribute.dateFormat == 'year'"  mode="year" 
            :status="message" :tips="tips" />
            <t-date-range-picker v-model="checkedValDate" class="my_date_picker_item" :class="option.attribute.labelAlign" :placeholder="option.attribute.placeholder"  v-if="option.attribute.dateFormat == 'month'"  mode="month" 
            :status="message" :tips="tips" />
            <t-date-range-picker v-model="checkedValDate" class="my_date_picker_item" :class="option.attribute.labelAlign" :placeholder="option.attribute.placeholder"  v-if="option.attribute.dateFormat == 'date'" mode="date" 
            :status="message" :tips="tips"  />
            <t-date-range-picker v-model="checkedValDate" class="my_date_picker_item" :class="option.attribute.labelAlign" :placeholder="option.attribute.placeholder"  v-if="option.attribute.dateFormat == 'datetime'" mode="date"
             :enableTimePicker="option.attribute.dateFormat == 'datetime'" :status="message" :tips="tips" />
        </div>
        <div v-else>
          <t-date-picker  v-model="checkedVal" class="my_date_picker_item" :class="option.attribute.labelAlign" v-if="option.attribute.dateFormat == 'year'"
          @change="clickHandler" :placeholder="option.attribute.placeholder" mode="year"
           :status="message" :tips="tips" @blur="checkValue" clearable />
          <t-date-picker  v-model="checkedVal" class="my_date_picker_item" :class="option.attribute.labelAlign" v-if="option.attribute.dateFormat == 'month'"
          @change="clickHandler" :placeholder="option.attribute.placeholder" mode="month"
           :status="message" :tips="tips" @blur="checkValue" clearable />
          <t-date-picker  v-model="checkedVal" class="my_date_picker_item" :class="option.attribute.labelAlign" v-if="option.attribute.dateFormat == 'date'"
          @change="clickHandler" :placeholder="option.attribute.placeholder" mode="date"
          :status="message" :tips="tips" @blur="checkValue" clearable />
          <t-date-picker  v-model="checkedVal" class="my_date_picker_item" :class="option.attribute.labelAlign" v-if="option.attribute.dateFormat == 'datetime'"
          @change="clickHandler" :placeholder="option.attribute.placeholder"  mode="date" :enableTimePicker="option.attribute.dateFormat == 'datetime'"
          :status="message" :tips="tips" @blur="checkValue" clearable />
        </div>
    </t-form-item>
  </t-form>
</template>

<script>
import { getDefaultValue } from "@/utils/refresh-cpt-data"; // 默认值方法

export default {
  name: "cpt-date-picker",
  props: {
    option: Object,
    refMap: Object,
    current:Object,
  },
  data() {
    return {
      checkedVal: "",
      daterange: false,//日期范围开关
      checkedValDate: [],
      message: "default",
      tips: "",
      uuid:null,
    }
  },
  // watch: {
  //   //监控日期范围  
  //   'option.attribute': {
  //     handler(obj) {
  //       this.daterange = obj.daterange;
  //       const defaultValue = getDefaultValue(obj, 'cpt-date-picker');
  //       if (defaultValue) {
  //         console.log(defaultValue, 'defaultValue')
  //         let str;
  //         if (Array.isArray(defaultValue)) {
  //           // 转换数组元素
  //           str = defaultValue.map(item => typeof item == 'undefined' ? item : String(item));
  //           console.log(str); // 输出: ["2024", undefined]
  //         }
  //         obj.daterange ? this.checkedValDate = str : this.checkedVal = defaultValue.toString();
  //       }
  //     },
  //     deep: true
  //   },
  // },
  computed: {
    setStyles() {
      return {
        "--width": this.current.cptWidth + "px",
        "--height": this.option.attribute.height + "px",
        "--indent": this.option.attribute.indent + "px",
        "--bgColor": this.option.attribute.bgColor,
        "--textColor": this.option.attribute.textColor,
        "--placholderColor": this.option.attribute.textPlaceholderColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--lineType": this.option.attribute.lineType,
        "--align": this.option.attribute.align,
        "--timeIcon": this.option.attribute.timeIcon ? 'block' : 'none',
        "--direction": this.option.attribute.direction,
      }
    },
  },
  mounted() {
    this.daterange = this.option.attribute.daterange;
    let defaultValue = getDefaultValue(this.option.attribute, 'cpt-date-picker')
    if(defaultValue) {
      try {
        let formatDate = new Date(defaultValue)
        let month = formatDate.getMonth() + 1 < 10 ? '0' + formatDate.getMonth() + 1 : formatDate.getMonth() + 1
    
        switch (this.option.attribute.dateFormat) {
            case 'year':
              defaultValue = formatDate.getFullYear()
              break;
            case 'month':
              defaultValue = formatDate.getFullYear() + '-' + month
              break;
            case 'date':
              let day = formatDate.getDate() < 10 ? '0' + formatDate.getDate() : formatDate.getDate()
              defaultValue = formatDate.getFullYear() + '-' + month + '-' + day
              break;
            default:
              break;
        }
      }catch(err) {
        console.error('初始化日期失败',err)
      }
     
    }
 
    
    console.log(defaultValue,this.option.attribute.dateFormat,'defaultValueqdqwqdwq');

    if (defaultValue) {
      console.log(defaultValue, 'defaultValue')
      let str;
      if (Array.isArray(defaultValue)) {
        // 转换数组元素
        str = defaultValue.map(item => typeof item == 'undefined' ? item : String(item));
        console.log(str,'????'); // 输出: ["2024", undefined]
      }
      this.option.attribute.daterange ? this.checkedValDate = str : this.checkedVal = defaultValue;
      this.clickHandler()
    }
    //   const defaultValue = getDefaultValue(this.option.attribute,'cpt-date-picker')
    //   // if (defaultValue) {
    //   //   let date = defaultValue.replace(/\+/g, ' ');
    //   //   let isDate = new Date(date).toString()
    //   //   if (isDate != 'Invalid Date') {
    //   //       this.checkedVal = date;
    //   //   }
    //   // }
    // }
  },
  created() {
     this.uuid = require("uuid").v1();
    //  this.refreshCptData(this.option.cptDataForm);
  },
  methods: {
    // handleFocus() {
    //   // this.$refs.datePicker.$refs.input.focus()
    //      @onFocus="handleFocus"
    // },
    clickHandler() {
      this.$emit("clickHandler", this.option.interaction, 'default', this.checkedVal, 'cpt-date-picker')
      this.checkValue();
    },
    // 校验方法
    checkValue() {
      const { attribute } = this.option;
      console.log(this.checkedVal, 'this.checkedVal')
      if (attribute.required && !this.checkedVal) {
        this.setValidationMessage(false);
        return false;
      } else {
        this.setValidationMessage(true);
        return true;
      }
    },
    setValidationMessage(isValid) {
      this.message = isValid ? "default" : "error";
      this.tips = isValid ? "" : `${this.option.attribute.label}必选`;
    },
    getValue() {
      console.log(this.option.attribute.daterange,'this.option.attribute.daterange')
      if (this.option.attribute.daterange) {
        return this.checkedValDate
      } else {
        return this.checkedVal
      }
    },
    setValue(value) {
      console.log(value, this.option.attribute.daterange ,'东山口大声道')
      if (this.option.attribute.daterange) {
        this.checkedValDate = value.split(',')
      } else {
        this.checkedVal = value
      }
    },

  }
}
</script>
<style scoped>
.t-form :deep(.t-form__controls){
  margin-left: 0px !important;
}
.t-form :deep(.t-form__controls-content) > div{
  width: 100%;
}
.my_date_picker_item {
  width: 100%;
}

.my_date_picker_item.top {
  width:calc(var(--width) - 1px);
}

.my_date_picker /deep/ .t-form__label {
   color:var(--textColor);
   font-style: var(--fontStyle);
   font-weight: var(--fontWeight);
   font-family: var(--fontFamily);
   font-size: var(--fontSize);
   line-height: var(--height);
}
.my_date_picker_item /deep/ .t-input .t-input__inner::placeholder {
   color: var(--placholderColor); 
 }

 .my_date_picker_item /deep/ .t-input .t-input__inner {
  padding-left: var(--indent);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  text-align: var(--align);
}

.my_date_picker_item  /deep/  .t-input {
  background-color: var(--bgColor);
  border-width: var(--borderSize);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  border-style: var(--lineType);
  height: var(--height);
}

.my_date_picker_item  /deep/.t-range-input {
   /* min-height: calc(var(--height) + 10px); */
   height: var(--height);
   border:none;
   padding:0px;
}

.my_date_picker_item /deep/.t-input--focused {
   box-shadow: none !important;
   border-color:none !important;
}

.my_date_picker_item /deep/.t-range-input-popup--visible .t-range-input {
   box-shadow: none !important;
   border-color:none !important;
}

.my_date_picker_item  /deep/ .t-range-input-popup--visible .t-range-input .t-input.t-is-focused {
  background-color: var(--bgColor);
}

 .my_date_picker_item /deep/ .t-range-input__inner-separator {
  color: var(--textColor);
}

 .my_date_picker_item /deep/  .t-range-input__inner .t-input:hover {
   background-color: var(--bgColor);
}

 .my_date_picker_item /deep/.t-range-input.t-range-input--suffix .t-range-input__suffix {
   display:var(--timeIcon);
   line-height: var(--height);
}

.my_date_picker_item /deep/ .t-input.t-input--suffix > .t-input__suffix-icon {
   display:var(--timeIcon);
   line-height: var(--height);
   display: flex;
   align-items: center;
}

</style>

